import { OrderState } from 'entities/OrderState';

export const isExternalNotApproved = (state) => {
	if (state == null) return state;
	return (
		(state & OrderState.is_external) && 
		!(state & OrderState.is_external_approved)
	);
};